import { ResourceDetails } from '../common';

export enum VmssAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type VmssActionType =
  | VmssAction.START
  | VmssAction.STOP
  | VmssAction.RESTART;

export enum VmssState {
  RUNNING = 'All running',
  STOPPED = 'All stopped',
  PARTIALLY_RUNNING = 'Partially running',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface VmssResourceDetails extends ResourceDetails {
  status: VmssState;
  location: string;
  resourceGroup: string;
  sku: string;
  capacity: number;
  instanceCount: number;
}
